import { useEffect, useState } from 'react';
import { RATE_LIMITED_EVENT, type RateLimitedDetail } from '../../api';
import { useT } from '../../i18n';

const AUTO_DISMISS_MS = 5000;

/**
 * Global transient banner for HTTP 429 rate_limited responses (both the
 * narrow per-endpoint throttles and the overall per-user cap in
 * config/app.php). Mounted once near the app root; listens for the event
 * api.ts dispatches on any 429, independent of which call triggered it.
 */
export function RateLimitToast() {
  const t = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onRateLimited = (e: Event) => {
      void (e as CustomEvent<RateLimitedDetail>).detail;
      setVisible(true);
    };
    window.addEventListener(RATE_LIMITED_EVENT, onRateLimited);
    return () => window.removeEventListener(RATE_LIMITED_EVENT, onRateLimited);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => setVisible(false), AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      role="alert"
      className="fixed inset-x-0 bottom-4 z-[100] mx-auto w-fit max-w-[min(92vw,420px)] rounded-xl px-4 py-2.5 text-[13px] font-medium leading-snug shadow-lg"
      style={{
        background: 'rgba(181, 82, 59, 0.96)',
        color: '#FFF7F2',
      }}
    >
      {t('common.rateLimited', 'Too many requests. Please slow down and try again shortly.')}
    </div>
  );
}
